export const projectUrls = {
  LOCAL: 'http://localhost:8000',
  SKARB: 'https://apteka-back.phrm.pro',
  APTEKA1: 'https://apteka1.aptekaskarb.ua',
  APTEKA2: 'https://apteka2.aptekaskarb.ua',
  KYIVLIKY: 'https://kyivliky.com.ua',
  KLASNAAPTEKA: 'https://klasnaapteka.com.ua',
  AKS_APTEKA: 'https://apteka-back.phrm.pro',
};
